import { Check } from "lucide-react";
import React from "react";

interface Step {
  number: number;
  label: string;
}

interface StepperProps {
  steps: Step[];
  activeStep: number;
}

const Stepper: React.FC<StepperProps> = ({ steps, activeStep }) => {
  return (
    <div className="flex w-full justify-center pt-5">
      <div className="flex w-[80%] items-start justify-between space-x-2">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`relative flex flex-1 items-center space-x-2 ${
              index < activeStep - 1 ? "text-gray-900" : "text-gray-300"
            }`}
          >
            <div
              className={`flex h-8 w-8 items-center justify-center rounded-full border-2 ${
                index === activeStep - 1
                  ? "border-gray-600 bg-gray-600 text-white"
                  : index < activeStep - 1
                    ? "border-gray-900 bg-black text-white"
                    : "border-gray-300"
              }`}
            >
              {index < activeStep - 1 ? <Check /> : step.number}
            </div>
            <div className="text-sm">{step.label}</div>
            {index !== steps.length - 1 && (
              <div
                className={`flex-1 ${
                  index < activeStep - 1 ? "bg-gray-900" : "bg-gray-300"
                }`}
                style={{ width: "100%", height: 2 }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
